module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-34.4c97eef1.png";